var AHTravelPairPageReview = (() => {
  var __defProp = Object.defineProperty;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __export = (target, all) => {
    for (var name in all)
      __defProp(target, name, { get: all[name], enumerable: true });
  };
  var __copyProps = (to, from, except, desc) => {
    if (from && typeof from === "object" || typeof from === "function") {
      for (let key of __getOwnPropNames(from))
        if (!__hasOwnProp.call(to, key) && key !== except)
          __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
    }
    return to;
  };
  var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

  // <stdin>
  var stdin_exports = {};
  __export(stdin_exports, {
    PAGE_REVIEW_CONFIG: () => PAGE_REVIEW_CONFIG2,
    captureActionState: () => captureActionState,
    createPageTracking: () => createPageTracking2
  });

  // preview/tracking_candidate.mjs
  var names = /* @__PURE__ */ new Set(["view", "start", "product_selected", "variant_selected", "stage_changed", "companion_skipped", "review_viewed", "revised_total_accepted", "cart_attempt"]);
  var outcomes = /* @__PURE__ */ new Set(["success", "failed", "uncertain", "partial_or_uncertain", "price_changed", "unavailable"]);
  var gid = (value, type) => typeof value === "string" && new RegExp(`^gid://shopify/${type}/[1-9]\\d*$`).test(value);
  function buildTrackingCandidate(input, context2, catalog) {
    if (!input || !names.has(input.name) || !context2 || !["en", "ar"].includes(context2.language) || !Number.isInteger(context2.stage) || context2.stage < 0 || context2.stage > 4 || !Array.isArray(catalog?.products)) return null;
    const selections = [];
    for (const role of ["main", "second"]) {
      const choice = context2[role];
      if (!choice) continue;
      if (!gid(choice.productId, "Product") || !gid(choice.variantId, "ProductVariant")) return null;
      const product = catalog.products.find((p) => p.id === choice.productId);
      if (!product?.variants?.some((v) => v.id === choice.variantId)) return null;
      selections.push({ role, product_id: choice.productId.split("/").at(-1), variant_id: choice.variantId.split("/").at(-1) });
    }
    if (context2.second && !context2.main || context2.second && context2.main.productId === context2.second.productId) return null;
    const payload = {
      schema_version: 1,
      qa: true,
      language: context2.language,
      stage: context2.stage,
      bag_count: selections.length,
      items: selections
    };
    if (input.name === "view" && context2.stage !== 0) return null;
    if (input.name === "start" && context2.stage !== 1) return null;
    if (["review_viewed", "revised_total_accepted", "companion_skipped"].includes(input.name) && (context2.stage !== 3 || !context2.main)) return null;
    if (input.name === "companion_skipped" && context2.second) return null;
    if (["product_selected", "variant_selected"].includes(input.name)) {
      if (!["main", "second"].includes(input.role)) return null;
      const selected = context2[input.role];
      if (!selected || context2.stage !== (input.role === "main" ? 1 : 2)) return null;
      if (input.name === "product_selected" && input.productId !== selected.productId) return null;
      if (input.name === "variant_selected" && input.variantId !== selected.variantId) return null;
      payload.role = input.role;
    }
    if (input.name === "stage_changed") {
      if (!Number.isInteger(input.fromStage) || input.fromStage < 0 || input.fromStage > 4 || input.fromStage === context2.stage) return null;
      payload.from_stage = input.fromStage;
    }
    if (input.name === "cart_attempt") {
      if (!context2.main || ![3, 4].includes(context2.stage) || !outcomes.has(input.outcome) || !Number.isInteger(input.itemCount) || input.itemCount < 0 || input.itemCount > selections.length) return null;
      if (input.outcome === "success" && input.itemCount !== selections.length) return null;
      if (["failed", "price_changed", "unavailable"].includes(input.outcome) && input.itemCount !== 0) return null;
      if (input.outcome === "partial_or_uncertain" && input.itemCount === 0) return null;
      payload.outcome = input.outcome;
      payload.items_added = input.itemCount;
    }
    payload.items.forEach(Object.freeze);
    Object.freeze(payload.items);
    return Object.freeze({ name: `ah_travel_pair_${input.name}`, data: Object.freeze(payload) });
  }

  // tracking-local/contract.mjs
  var MEASUREMENT_ID = "G-TNS839QV8H";
  var EVENT_NAMES = Object.freeze(["view", "start", "product_selected", "variant_selected", "stage_changed", "companion_skipped", "review_viewed", "revised_total_accepted", "cart_attempt"].map((name) => `ah_travel_pair_${name}`));
  var UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  var isMode = (value) => value === "qa" || value === "production";
  var plain = (value) => value && typeof value === "object" && !Array.isArray(value) && [Object.prototype, null].includes(Object.getPrototypeOf(value));
  var numericId = (value) => typeof value === "string" && /^[1-9]\d{0,19}$/.test(value);
  function validIdentity(identity) {
    return plain(identity) && typeof identity.clientId === "string" && /^\d{1,20}\.\d{1,20}$/.test(identity.clientId) && typeof identity.sessionId === "string" && /^[1-9]\d{0,15}$/.test(identity.sessionId) && Number.isSafeInteger(Number(identity.sessionId));
  }
  function flatten(candidate, meta) {
    const d = candidate.data;
    const wire = {
      schema_version: 1,
      mode: meta.mode,
      language: d.language,
      stage: d.stage,
      bag_count: d.bag_count,
      journey_id: meta.journeyId,
      sequence: meta.sequence,
      event_id: `${meta.journeyId}_${meta.sequence}`,
      ga4_client_id: meta.identity.clientId,
      ga4_session_id: meta.identity.sessionId
    };
    for (const item of d.items) {
      wire[`${item.role}_product_id`] = item.product_id;
      wire[`${item.role}_variant_id`] = item.variant_id;
    }
    for (const key of ["role", "from_stage", "outcome", "items_added"]) if (Object.hasOwn(d, key)) wire[key] = d[key];
    return wire;
  }
  function normalizeWireEvent(name, wire, catalog) {
    try {
      if (!EVENT_NAMES.includes(name) || !plain(wire) || wire.schema_version !== 1 || !isMode(wire.mode) || typeof wire.journey_id !== "string" || !UUID.test(wire.journey_id) || !Number.isSafeInteger(wire.sequence) || wire.sequence < 1 || wire.sequence > 1e6 || wire.event_id !== `${wire.journey_id}_${wire.sequence}` || !validIdentity({ clientId: wire.ga4_client_id, sessionId: wire.ga4_session_id })) return null;
      const context2 = { language: wire.language, stage: wire.stage };
      for (const role of ["main", "second"]) {
        if (Object.hasOwn(wire, `${role}_product_id`) || Object.hasOwn(wire, `${role}_variant_id`)) {
          if (!numericId(wire[`${role}_product_id`]) || !numericId(wire[`${role}_variant_id`])) return null;
          context2[role] = { productId: `gid://shopify/Product/${wire[`${role}_product_id`]}`, variantId: `gid://shopify/ProductVariant/${wire[`${role}_variant_id`]}` };
        }
      }
      if (context2.main && catalog?.products?.find((product) => product.id === context2.main.productId)?.main !== true) return null;
      const suffix = name.slice("ah_travel_pair_".length);
      const input = { name: suffix, role: wire.role, fromStage: wire.from_stage, outcome: wire.outcome, itemCount: wire.items_added };
      if (wire.role && context2[wire.role]) Object.assign(input, { productId: context2[wire.role].productId, variantId: context2[wire.role].variantId });
      const candidate = buildTrackingCandidate(input, context2, catalog);
      if (!candidate) return null;
      const expected = flatten(candidate, { mode: wire.mode, journeyId: wire.journey_id, sequence: wire.sequence, identity: { clientId: wire.ga4_client_id, sessionId: wire.ga4_session_id } });
      const keys = Object.keys(wire);
      if (keys.length !== Object.keys(expected).length || keys.some((key) => !Object.hasOwn(expected, key) || wire[key] !== expected[key])) return null;
      return Object.freeze({ name, data: Object.freeze(expected) });
    } catch {
      return null;
    }
  }
  function prepareWireEvent(candidate, meta, catalog) {
    try {
      if (!candidate || !meta || !isMode(meta.mode) || !UUID.test(meta.journeyId) || !validIdentity(meta.identity)) return null;
      return normalizeWireEvent(candidate.name, flatten(candidate, meta), catalog);
    } catch {
      return null;
    }
  }
  function analyticsAllowed(getPrivacy) {
    try {
      return getPrivacy?.()?.analyticsProcessingAllowed?.() === true;
    } catch {
      return false;
    }
  }
  async function bounded(operation, timeoutMs = 1e3) {
    let timer;
    try {
      return await Promise.race([
        Promise.resolve().then(operation),
        new Promise((resolve) => {
          timer = setTimeout(() => resolve(null), timeoutMs);
        })
      ]);
    } catch {
      return null;
    } finally {
      clearTimeout(timer);
    }
  }

  // tracking-local/page-bridge.mjs
  function createGoogleIdentityProvider({ windowLike, getPrivacy, timeoutMs = 1e3 } = {}) {
    return async () => {
      if (!analyticsAllowed(getPrivacy) || typeof windowLike?.gtag !== "function") return null;
      const get = (field) => bounded(() => new Promise((resolve) => {
        if (!analyticsAllowed(getPrivacy)) return resolve(null);
        windowLike.gtag("get", MEASUREMENT_ID, field, (value) => resolve(value));
      }), timeoutMs);
      const [clientId, sessionValue] = await Promise.all([get("client_id"), get("session_id")]);
      const sessionId = typeof sessionValue === "number" && Number.isSafeInteger(sessionValue) ? String(sessionValue) : sessionValue;
      const identity = { clientId, sessionId };
      return analyticsAllowed(getPrivacy) && validIdentity(identity) ? identity : null;
    };
  }
  function createPageBridge({
    enabled = false,
    mode = "qa",
    windowLike,
    getCatalog,
    getIdentity,
    identityVerified = false,
    makeJourneyId,
    timeoutMs = 1e3,
    isAuthorized = () => true
  } = {}) {
    let initialized = false, stopped = false, pendingInit = null, lastSequence = 0, epoch = 0, journeyId = null;
    const usedJourneys = /* @__PURE__ */ new Set();
    const getPrivacy = () => windowLike?.Shopify?.customerPrivacy;
    const eligible = () => {
      try {
        return enabled === true && isMode(mode) && !stopped && isAuthorized() === true && analyticsAllowed(getPrivacy);
      } catch {
        return false;
      }
    };
    const consentChanged = () => {
      epoch++;
      journeyId = null;
    };
    const identityProvider = getIdentity ?? createGoogleIdentityProvider({ windowLike, getPrivacy, timeoutMs });
    return Object.freeze({
      async initialize() {
        if (enabled !== true || !isMode(mode) || stopped) return { status: "disabled" };
        if (initialized) return { status: "initialized" };
        if (pendingInit) return pendingInit;
        pendingInit = (async () => {
          if (typeof windowLike?.document?.addEventListener !== "function" || typeof windowLike.document.removeEventListener !== "function") return { status: "privacy_unavailable" };
          if (typeof getPrivacy()?.analyticsProcessingAllowed !== "function") {
            const loaded = await bounded(() => new Promise((resolve) => {
              if (typeof windowLike?.Shopify?.loadFeatures !== "function") return resolve(false);
              windowLike.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], (error) => resolve(!error));
            }), timeoutMs);
            if (!loaded || typeof getPrivacy()?.analyticsProcessingAllowed !== "function") return { status: "privacy_unavailable" };
          }
          if (stopped) return { status: "disabled" };
          windowLike.document.addEventListener("visitorConsentCollected", consentChanged);
          initialized = true;
          return { status: "initialized" };
        })().catch(() => ({ status: "privacy_unavailable" }));
        try {
          return await pendingInit;
        } finally {
          pendingInit = null;
        }
      },
      async record(input, context2, sequence) {
        if (enabled !== true || stopped || !isMode(mode)) return { status: "disabled" };
        if (!initialized) return { status: "not_initialized" };
        if (!Number.isSafeInteger(sequence) || sequence < 1 || sequence > 1e6) return { status: "invalid_sequence" };
        if (sequence <= lastSequence) return { status: "duplicate_or_old" };
        lastSequence = sequence;
        if (!eligible()) return { status: "permission_denied" };
        if (identityVerified !== true) return { status: "identity_unverified" };
        try {
          const candidate = buildTrackingCandidate(input, context2, getCatalog?.());
          if (!candidate) return { status: "invalid_event" };
          const originalEpoch = epoch;
          if (!journeyId) {
            const nextId = makeJourneyId?.();
            if (typeof nextId !== "string" || !UUID.test(nextId) || usedJourneys.has(nextId) || usedJourneys.size >= 32) return { status: "identifier_unavailable" };
            usedJourneys.add(nextId);
            journeyId = nextId;
          }
          const originalJourney = journeyId;
          const identity = await bounded(identityProvider, timeoutMs);
          if (!eligible() || epoch !== originalEpoch) return { status: "permission_changed" };
          if (!validIdentity(identity)) return { status: "identity_unavailable" };
          const event = prepareWireEvent(candidate, { mode, journeyId: originalJourney, sequence, identity }, getCatalog?.());
          if (!event) return { status: "invalid_event" };
          if (typeof windowLike?.Shopify?.analytics?.publish !== "function") return { status: "publisher_unavailable" };
          if (!eligible() || epoch !== originalEpoch) return { status: "permission_changed" };
          const result = await bounded(() => {
            if (!eligible() || epoch !== originalEpoch) return false;
            return windowLike.Shopify.analytics.publish(event.name, event.data);
          }, timeoutMs);
          return { status: result === true ? "published_to_shopify" : "publication_unconfirmed" };
        } catch {
          return { status: "tracking_failed" };
        }
      },
      dispose() {
        stopped = true;
        epoch++;
        journeyId = null;
        if (initialized) windowLike.document.removeEventListener("visitorConsentCollected", consentChanged);
        initialized = false;
      }
    });
  }

  // tracking-local/preview-binding.mjs
  var PREVIEW_REVIEW_CONFIG = Object.freeze({
    enabled: false,
    publishingApproved: false,
    identityVerified: false,
    mode: "qa",
    previewUrl: null
  });
  function captureActionState(state) {
    const choice = (role) => state?.[`${role}Product`] && state?.[`${role}Variant`] ? Object.freeze({ productId: state[`${role}Product`], variantId: state[`${role}Variant`] }) : null;
    const main = choice("main");
    return Object.freeze({
      language: state?.lang,
      stage: state?.step,
      main,
      second: main ? choice("second") : null,
      mainProductId: state?.mainProduct ?? null,
      secondProductId: state?.secondProduct ?? null
    });
  }
  var context = (snapshot) => Object.freeze({ language: snapshot.language, stage: snapshot.stage, main: snapshot.main, second: snapshot.second });
  function createActionTracking({ windowLike, config, bridgeFactory = createPageBridge, scopeCheck } = {}) {
    config = Object.freeze({ ...config });
    const approvedScope = (value, target) => {
      try {
        return typeof scopeCheck === "function" && scopeCheck(value, target) === true;
      } catch {
        return false;
      }
    };
    const enabled = approvedScope(config, windowLike);
    let bridge = null, ready = false, stopped = false, generation = 0, sequence = 0, catalog = null, catalogLoaded = false;
    const send = (input, snapshot) => {
      if (!ready || stopped || !bridge || !approvedScope(config, windowLike)) return 0;
      try {
        void Promise.resolve(bridge.record(input, context(snapshot), ++sequence)).catch(() => {
        });
      } catch {
      }
      return 1;
    };
    const initialize = async (readSnapshot) => {
      if (!enabled || stopped || !approvedScope(config, windowLike)) return { status: "disabled" };
      const originalGeneration = ++generation;
      ready = false;
      bridge?.dispose();
      sequence = 0;
      try {
        const current = bridgeFactory({
          enabled: true,
          mode: config.mode,
          identityVerified: true,
          windowLike,
          getCatalog: () => catalog,
          makeJourneyId: () => windowLike.crypto?.randomUUID?.(),
          getIdentity: createGoogleIdentityProvider({
            windowLike,
            getPrivacy: () => approvedScope(config, windowLike) ? windowLike.Shopify?.customerPrivacy : null
          }),
          isAuthorized: () => approvedScope(config, windowLike)
        });
        bridge = current;
        const result = await current.initialize();
        if (stopped || generation !== originalGeneration) {
          current.dispose();
          return { status: "cancelled" };
        }
        ready = result?.status === "initialized";
        const snapshot = readSnapshot();
        if (ready && snapshot.stage === 0) send({ name: "view" }, snapshot);
        return { status: ready ? "initialized" : "unavailable" };
      } catch {
        ready = false;
        bridge?.dispose();
        return { status: "unavailable" };
      }
    };
    return Object.freeze({
      catalogReady(value, readSnapshot) {
        if (catalogLoaded) return Promise.resolve({ status: "already_initialized" });
        catalogLoaded = true;
        catalog = value;
        return initialize(readSnapshot);
      },
      afterAction(before, after, action, readSnapshot = () => after) {
        if (!enabled || stopped) return 0;
        if (action.type === "action" && action.name === "restart") {
          void initialize(readSnapshot);
          return 0;
        }
        if (!ready) return 0;
        let attempts = 0;
        if (["product", "variant"].includes(action.type) && ["main", "second"].includes(action.role)) {
          const role = action.role, chosen = after[role], previous = before[role];
          if (!chosen) return 0;
          if (before[`${role}ProductId`] !== after[`${role}ProductId`] || !previous) {
            attempts += send({ name: "product_selected", role, productId: chosen.productId }, after);
          }
          if (action.type === "variant" && chosen.variantId !== previous?.variantId) {
            attempts += send({ name: "variant_selected", role, variantId: chosen.variantId }, after);
          }
        }
        if (action.type === "action") {
          if (action.name === "start" && before.stage === 0 && after.stage === 1) attempts += send({ name: "start" }, after);
          if (before.stage !== after.stage) attempts += send({ name: "stage_changed", fromStage: before.stage }, after);
          if (action.name === "skip" && before.stage === 2 && after.stage === 3 && !after.second) attempts += send({ name: "companion_skipped" }, after);
          if (before.stage !== 3 && after.stage === 3) attempts += send({ name: "review_viewed" }, after);
        }
        return attempts;
      },
      acceptedTotal(snapshot) {
        return send({ name: "revised_total_accepted" }, snapshot);
      },
      cartOutcome(snapshot, outcome) {
        const status = outcome?.status;
        if (!["success", "failed", "uncertain", "partial_or_uncertain", "price_changed", "unavailable"].includes(status)) return 0;
        const itemCount = ["success", "partial_or_uncertain"].includes(status) ? outcome.added?.filter((item) => item.quantityAdded > 0).length ?? 0 : 0;
        return send({ name: "cart_attempt", outcome: status, itemCount }, snapshot);
      },
      dispose() {
        stopped = true;
        ready = false;
        generation++;
        bridge?.dispose();
      }
    });
  }

  // tracking-local/page-binding.mjs
  var PAGE_REVIEW_CONFIG = Object.freeze({
    enabled: false,
    publishingApproved: false,
    identityVerified: false,
    mode: "production",
    pageHandle: null
  });
  function approvedPageScope(config, windowLike) {
    try {
      if (config.enabled !== true || config.publishingApproved !== true || config.identityVerified !== true || config.mode !== "production" || windowLike.travelPairRuntime?.mode !== "shopify" || typeof config.pageHandle !== "string" || !/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(config.pageHandle)) return false;
      const actual = new URL(windowLike.location.href);
      if (actual.origin !== "https://arctichunter-eg.com" || actual.username || actual.password) return false;
      const paths = ["/en-eg/", "/ar-eg/"].map((root) => `${root}pages/${config.pageHandle}`);
      if (config.includeRootPath === true) paths.push(`/pages/${config.pageHandle}`);
      if (!paths.includes(actual.pathname)) return false;
      return !["view", "preview_theme_id", "preview", "review"].some((key) => actual.searchParams.has(key));
    } catch {
      return false;
    }
  }
  function createPageTracking({ windowLike, config = PAGE_REVIEW_CONFIG, bridgeFactory } = {}) {
    return createActionTracking({ windowLike, config, bridgeFactory, scopeCheck: approvedPageScope });
  }

  // <stdin>
  var PAGE_REVIEW_CONFIG2 = Object.freeze({ "enabled": true, "publishingApproved": true, "identityVerified": true, "mode": "production", "pageHandle": "travel-pair", "includeRootPath": true });
  var createPageTracking2 = ({ windowLike } = {}) => createPageTracking({ windowLike, config: PAGE_REVIEW_CONFIG2 });
  return __toCommonJS(stdin_exports);
})();
